module.exports = __webpack_public_path__ + "static/img/img_bg_03.f5bd619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_bg_03.jpg
// module id = 150
// module chunks = 1